import React, { useState, useRef, useEffect } from 'react';
import {
  ExpandableMenu,
  EllipsisMenuButton,
  MenuList,
  MenuItem,
} from '@grnhse/seedling/lib/birch/components/expandable_menu';
import { IconButton } from '@grnhse/seedling/lib/birch/components/buttons/icon_buttons';
import EllipsisIcon from '@grnhse/seedling/lib/birch/icons/ellipsis';
import { withLocalePrefix } from 'shared/utils/translation';
import { useRediscoveryApplication } from 'talent_matching/talent_rediscovery/hooks/use_rediscovery_applications';
import styled from 'styled-components';
import Tokens from '@grnhse/seedling/lib/birch/tokens';

const t = withLocalePrefix('talent_matching.rediscovery.table.actions');

const Wrapper = styled.div`
  padding-top: ${Tokens.spacing['1']};
  height: 100%;
`;

type RediscoveryRowActionsProps = {
  applicationId: number;
};

const RediscoveryRowActions = ({
  applicationId,
}: RediscoveryRowActionsProps) => {
  const { application } = useRediscoveryApplication(applicationId);
  const [menuMounted, setMenuMounted] = useState(false);
  const shouldOpenRef = useRef(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  // After the real menu mounts, programmatically open it via mousedown
  // (@reach/menu-button uses mousedown, not click, to toggle the menu)
  useEffect(() => {
    if (menuMounted && shouldOpenRef.current) {
      shouldOpenRef.current = false;
      requestAnimationFrame(() => {
        const btn = wrapperRef.current?.querySelector(
          '[data-reach-menu-button]'
        ) as HTMLButtonElement | null;
        if (btn) {
          btn.dispatchEvent(
            new MouseEvent('mousedown', { bubbles: true, cancelable: true })
          );
        }
      });
    }
  }, [menuMounted]);

  if (!application) {
    return null;
  }

  const handleWrapperClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  const handlePlaceholderClick = () => {
    shouldOpenRef.current = true;
    setMenuMounted(true);
  };

  const handleViewCandidate = () => {
    // Placeholder - will be implemented in future
  };

  const handleAddToJob = () => {
    // Placeholder - will be implemented in future
  };

  if (!menuMounted) {
    return (
      <Wrapper onClick={handleWrapperClick} onMouseUp={handleWrapperClick}>
        <IconButton
          icon={EllipsisIcon}
          label={t('actions')}
          onClick={handlePlaceholderClick}
        />
      </Wrapper>
    );
  }

  return (
    <Wrapper
      ref={wrapperRef}
      onClick={handleWrapperClick}
      onMouseUp={handleWrapperClick}
    >
      {/* @ts-expect-error - TS2322 */}
      <ExpandableMenu dangerouslyBypassScrollLock>
        <EllipsisMenuButton aria-label={t('actions')} />
        <MenuList>
          <MenuItem onSelect={handleViewCandidate} disabled>
            {t('view_candidate')}
          </MenuItem>
          <MenuItem onSelect={handleAddToJob} disabled>
            {t('add_to_job')}
          </MenuItem>
        </MenuList>
      </ExpandableMenu>
    </Wrapper>
  );
};

export default RediscoveryRowActions;
